export const stringToBool = (str: string): boolean =>
  ["true", "yes", "1"].indexOf(str.toLowerCase()) > -1;
